// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"5c6a0cfb","202":"e754a00d","410":"27f78bfe","506":"5444f2c3","637":"b39f52d9","750":"f9211a1c","778":"5a247ba3","787":"9f47c320"}[chunkId] + ".chunk.js";
};